import { useEffect } from "react";

const SITE = "https://accessxhvm.co.nz";

const setMeta = (selector, attr, value) => {
  const el = document.querySelector(selector);
  if (el && value) el.setAttribute(attr, value);
};

export function useDocumentMeta(title, description, { path = "/", type = "website", image } = {}) {
  useEffect(() => {
    const url = `${SITE}${path}`;
    document.title = title;
    setMeta('meta[name="description"]', "content", description);
    setMeta('link[rel="canonical"]', "href", url);
    setMeta('meta[property="og:title"]', "content", title);
    setMeta('meta[property="og:description"]', "content", description);
    setMeta('meta[property="og:url"]', "content", url);
    setMeta('meta[property="og:type"]', "content", type);
    setMeta('meta[name="twitter:title"]', "content", title);
    setMeta('meta[name="twitter:description"]', "content", description);
    if (image) {
      setMeta('meta[property="og:image"]', "content", `${SITE}${image}`);
      setMeta('meta[name="twitter:image"]', "content", `${SITE}${image}`);
    }
  }, [title, description, path, type, image]);
}

export function useJsonLd(id, data) {
  useEffect(() => {
    if (!data) return;
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = id;
    script.text = JSON.stringify({ "@context": "https://schema.org", ...data });
    document.head.appendChild(script);
    return () => document.getElementById(id)?.remove();
  }, [id, data]);
}

export const breadcrumbs = (items) => ({
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: `${SITE}${it.path}`,
  })),
});
